import { gql } from '@apollo/client';

// GraphQL Query
export const GET_CONTACT_LP_PLATFORM = gql`
  query GetContactLpPlatform($id: ID!) {
    node(id: $id) {
      ... on ContactNode {
        id
        name
        lpPlatformIds {
          id
          lpPlatform {
            id
            name
          }
          lpPlatformAdvisor {
            id
            name
          }
          lpPlatformParent {
            id
            name
          }
          lpPlatformSuppress
          lpPlatformSuppressEmails
          dateLpPlatformSuppressUnchecked
          reasonForUncheckedLpPlatformSuppress
        }
      }
    }
  }
`;

// UI Data Types
export interface ContactLpPlatformData {
  dateLpPlatformSuppressUnchecked: string;
  lpPlatform: string;
  lpPlatformAdvisor: string;
  lpPlatformAdvisorId: null | string;
  lpPlatformId: null | string;
  lpPlatformParent: string;
  lpPlatformParentId: null | string;
  lpPlatformSuppress: boolean;
  lpPlatformSuppressEmails: boolean;
  reasonForUncheckedLpPlatformSuppress: string;
}

export interface ContactNodeWithLpPlatform {
  id: string;
  lpPlatformIds?: LpPlatformNode | LpPlatformNode[] | null;
  name: string;
}

// API Response Types
export interface LpPlatformLookup {
  id: string;
  name: string;
}

export interface LpPlatformNode {
  dateLpPlatformSuppressUnchecked?: null | string;
  id: string;
  lpPlatform?: LpPlatformLookup | null;
  lpPlatformAdvisor?: LpPlatformLookup | null;
  lpPlatformParent?: LpPlatformLookup | null;
  lpPlatformSuppress?: boolean | null;
  lpPlatformSuppressEmails?: boolean | null;
  reasonForUncheckedLpPlatformSuppress?: null | string;
}

// Helper functions
export function createEmptyContactLpPlatformData(): ContactLpPlatformData {
  return {
    dateLpPlatformSuppressUnchecked: '',
    lpPlatform: '',
    lpPlatformAdvisor: '',
    lpPlatformAdvisorId: null,
    lpPlatformId: null,
    lpPlatformParent: '',
    lpPlatformParentId: null,
    lpPlatformSuppress: false,
    lpPlatformSuppressEmails: false,
    reasonForUncheckedLpPlatformSuppress: ''
  };
}

export function mapContactLpPlatform(
  node: LpPlatformNode
): ContactLpPlatformData {
  return {
    dateLpPlatformSuppressUnchecked: node.dateLpPlatformSuppressUnchecked ?? '',
    lpPlatform: node.lpPlatform?.name ?? '',
    lpPlatformAdvisor: node.lpPlatformAdvisor?.name ?? '',
    lpPlatformAdvisorId: node.lpPlatformAdvisor?.id ?? null,
    lpPlatformId: node.lpPlatform?.id ?? null,
    lpPlatformParent: node.lpPlatformParent?.name ?? '',
    lpPlatformParentId: node.lpPlatformParent?.id ?? null,
    lpPlatformSuppress: node.lpPlatformSuppress ?? false,
    lpPlatformSuppressEmails: node.lpPlatformSuppressEmails ?? false,
    reasonForUncheckedLpPlatformSuppress:
      node.reasonForUncheckedLpPlatformSuppress ?? ''
  };
}
